import React, { Component } from 'react'
import { connect } from 'react-redux'
import Download from 'downloadjs'
import { fetchWithRetry } from '../../authorisation'
import { errorHandler } from '../error-handling'
import ErrorDisplayFatal from '../../ui/error-display-fatal'

const defaultState = {
  loading: false,
  success: null,
  errors: {},
  apiFailed: false,
}

const withDownloadCSV = WrappedComponent => {
  class DownloadCSV extends Component {
    constructor(props) {
      super(props)
      this.state = defaultState
      this.download = this.download.bind(this)
    }

    download({ url, payload, fileName = 'export.csv', method = 'POST' }) {
      this.onStart()
      const { token, dispatchAction } = this.props

      return fetchWithRetry(
        url,
        {
          token,
          method,
          accept: 'text/csv',
          body: payload,
        },
        dispatchAction
      )
        .then(response => {
          if (response.ok) {
            response.blob().then(csvData => {
              Download(csvData, fileName, 'text/csv')
              this.onComplete()
            })
          } else {
            response.json().then(payload => {
              this.onError(payload.errors)
            })
          }
        })
        .catch(error => this.APIFailed(error))
    }

    onStart() {
      this.setState({
        ...defaultState,
        loading: true,
        apiFailed: false,
      })
    }

    onComplete() {
      this.setState({
        ...defaultState,
        loading: false,
        success: true,
      })
    }

    onError(errors) {
      this.setState({
        loading: false,
        success: false,
        errors: errorHandler({ errors }),
      })
    }

    APIFailed(error) {
      this.setState({
        loading: false,
        success: false,
        errors: errorHandler({ errors: ['Failed to talk to API', error.message] }),
        apiFailed: true,
      })
    }

    render() {
      const { loading, success, errors } = this.state

      const csv = {
        submit: this.download,
        state: {
          loading,
          success,
          errors,
        },
      }

      if (this.state.apiFailed) {
        return <ErrorDisplayFatal errors={errors} />
      }

      return <WrappedComponent remote_request={csv} {...this.props} />
    }
  }

  const mapDispatchToProps = dispatch => ({
    dispatchAction: action => dispatch(action),
  })

  const mapStateToProps = state => ({
    token: state.authorisation.jwt,
  })

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(DownloadCSV)
}

export default withDownloadCSV



// WEBPACK FOOTER //
// ./src/io/download-csv/container.js